import { FC } from "react"
import { SubAdminConfirm } from "../../../../module/settings/containers/subAdmin/confirm"

export const SubAdminConfirmPage: FC = () => <SubAdminConfirm />
